export class DeviceOrder {
  id: number;
  status: string;
  requested_on: number;
  payment_received: number;
  user: {
      id: number,
      first_name: string,
      last_name: string,
      fullname: string,
  };
  address: {
      line1: string,
      line2: string,
      suburb: string,
      city: string,
      postcode: number,
      country: string
  };
  fullAddress: string;
}
